<template>
  <div class="container">
    <van-form @submit="onSubmitFind" v-if="!state.isReplyFind">
      <van-field
        v-model="findFormData.tel"
        required
        name="tel"
        label="查询电话"
        label-align="right"
        placeholder="请输入举报时填写的电话"
        :rules="[
          {
            pattern: mobileReg,
            required: true,
            message: '请填写正确的电话号码'
          }
        ]"
      >
        <template #button>
          <van-button
            size="mini"
            round
            native-type="button"
            style="width: 80px"
            @click="findSendSMS"
            :disabled="state.findSMS.disabled"
            :type="state.findSMS.primary"
            >{{ state.findSMS.text }}</van-button
          >
        </template>
      </van-field>
      <van-field
        v-model="findFormData.code"
        name="code"
        required
        label="验证码"
        label-align="right"
        placeholder="请填写正确的验证码"
        type="number"
        maxlength="6"
        @update:model-value="verifyUpdateFind"
        :rules="[
          {
            pattern: /\d{6}/,
            required: true,
            message: '请填写正确的验证码'
          }
        ]"
      />
      <van-row justify="center" class="van-container-top">
        <van-col span="10">
          <van-button
            block
            round
            :disabled="state.disabledFindSubmit"
            type="primary"
            native-type="submit"
            >立即查询</van-button
          >
        </van-col>
      </van-row>
    </van-form>
    <van-row justify="center" class="van-container-top" v-else>
      <van-col span="10">
        <van-button block round type="primary" native-type="submit" @click="reFindReply">
          重新查询
        </van-button>
      </van-col>
    </van-row>
    <div class="search-content">
      <h2 class="search-title">查询结果</h2>
      <table class="search-table">
        <col align="center" width="50" />
        <col />
        <col align="center" width="60" />
        <thead>
          <tr>
            <th>序号</th>
            <th>回复内容</th>
            <th>进度</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="state.replyData.length">
            <tr v-for="(replyItem, index) in state.replyData" :key="index">
              <td class="search-tac">{{ index + 1 }}</td>
              <td>
                <h3 class="reply-subject">举报主题: {{ replyItem.report_theme }}</h3>
                <div class="reply-info">
                  <strong>被举报人: </strong>{{ replyItem.informer }}<br />
                  <!-- <strong>被举报站点: </strong>{{ replyItem.department }} -->
                </div>
                <div class="reply-content">
                  <strong>举报内容: </strong>
                  {{ replyItem.content ? replyItem.content : '暂无内容' }}
                </div>
                <div v-if="replyItem.status === 2" class="reply-feedback">
                  <strong>反馈结果: </strong>
                  {{ replyItem.reply_content ? replyItem.reply_content : '暂无内容' }}
                </div>
                <p v-if="replyItem.status === 2" class="reply-time">
                  回复时间: {{ moment(replyItem.reply_time).format('YYYY/MM/DD') }}
                </p>
              </td>
              <td :class="replyItem.status === 2 ? 'search-tac' : 'search-tac search-green'">
                {{ replyItem.status === 2 ? '已完成' : '处理中' }}
              </td>
            </tr>
          </template>
          <tr v-else>
            <td colspan="3">
              <van-empty description="暂无查询结果消息" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import { Row, Col, Button, Field, Form, Empty } from 'vant';
import { localStorageUtil } from '@/utils';
import { state, findFormData, mobileReg } from '../helper/data';
import progress from '../helper/progress';
export default {
  name: 'Progress',
  components: {
    'van-button': Button,
    'van-field': Field,
    'van-form': Form,
    'van-row': Row,
    'van-col': Col,
    'van-empty': Empty
  },
  setup() {
    const tokenInfo = localStorageUtil.getItem('findInfoTokenNew');
    if (tokenInfo) {
      state.isReplyFind = true;
      if (!state.replyData.length) {
        progress.onSubmitFind({ access_token: tokenInfo });
      }
    }
    return {
      state,
      findFormData,
      mobileReg,
      moment,
      ...progress
    };
  }
};
</script>

<style lang="scss">
@import '../style/config';

.search-content {
  padding: 40px;
  font-size: 28px;
  min-height: 600px;
  .search-title {
    font-size: 32px;
  }
  .search-tac {
    padding: 40px 0;
    text-align: center;
  }
  .search-green {
    color: #0eab4a;
  }
  .search-table {
    width: 100%;
    margin-top: 20px;
    color: #999;
    border-spacing: 0;
    border: 2px solid #ccc;
    border-width: 2px 0 0 2px;
    td,
    th {
      padding: 4px 8px;
      border: 2px solid #ccc;
      border-width: 0 2px 2px 0;
      word-break: break-all;
      word-wrap: break-word;
    }
    th {
      background-color: #eee;
    }
  }
}
.reply {
  &-subject {
    font-size: 28px;
    // font-weight: normal;
    color: #222;
    margin: 10px 0 15px 0;
  }
  &-info {
    font-size: 14px;
    color: #333;
    line-height: 2;
    word-break: break-all;
    word-wrap: break-word;
    margin-bottom: 10px;
    strong {
      color: #333;
    }
  }
  &-content {
    color: #333;
    font-size: 24px;
    line-height: 1.5;
    word-break: break-all;
    word-wrap: break-word;
    // text-indent: 1em;
    p {
      margin-bottom: 10px;
      // text-indent: 1em;
    }
  }
  &-feedback {
    margin-top: 10px;
    background: #eee;
    padding: 10px;
    font-size: 24px;
    line-height: 1.5;
    word-break: break-all;
    word-wrap: break-word;
    color: #222;
    border-radius: 8px;
    // text-indent: 1em;
    strong {
      color: $primary;
    }
    p {
      margin-bottom: 10px;
      text-indent: 1em;
      color: #222;
    }
  }
  &-time {
    margin: 10px 0;
    text-align: right;
    font-size: 24px;
  }
}
</style>
